import React from 'react'
import BackArrowImage from "../../assets/newPurchase/backArrow.svg"

import "./backArrow.scss"
const BackArrow = (props) => {
    return (
        <div className={!props.removeClass ? "arrow-container-np" : ""}>
        <img src={BackArrowImage} alt="Back" className="back-arrow-np"/>
      </div>
    )
}

export default BackArrow
